export default [
  {
    // 1. 提交用户反馈 POST /submit
    name: 'submit',
    base: {
      url: '/General/submit',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {}
  },
  {
    // 2. 查询反馈状态 GET /{feedbackId}
    name: 'getFeedbackState',
    base: {
      url: '/General/', // 使用时在末尾拼接 feedbackId
      method: 'get',
      headers: {},
      data: {}
    },
    config: {}
  },
  {
    // 3. 查询用户的所有反馈 GET /user/{userId}
    name: 'getUserFeedbackList',
    // 兼容历史拼写错误，避免旧调用点在彻底清理前直接失效。
    aliases: ['getUserBacklist'],
    base: {
      url: '/General/user/', // 使用时在末尾拼接 userId
      method: 'get',
      headers: {},
      data: {}
    },
    config: {}
  },
  {
    // 4. 查询用户的所有任务 GET /tasks/user/{userId}
    name: 'getTasksList',
    base: {
      url: '/General/tasks/user/', // 使用时在末尾拼接 userId
      method: 'get',
      headers: {},
      data: {}
    },
    config: {}
  }
]
